import { Outlet } from 'react-router-dom'
import { Container } from './styles'
import { HeadAdmin } from '../../components/HeadAdmin'

export default function AdminPage() {
  return (
    <Container>
      <HeadAdmin />
      <Outlet />
    </Container>
  )
}
